<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice with-inner">
        <div
          class="fakeoverlay"
          :class="{disabled: !selectStatus}"
          @click="selectStatus =! selectStatus"
        />
        <div class="inner-property">
          <div class="mode">
            <el-radio
              v-model="mode"
              :label="true"
              :disabled="!selectStatus"
              @change="changeOptionCSS"
            >
              Internal
            </el-radio>
            <el-radio
              v-model="mode"
              :label="false"
              :disabled="!selectStatus"
              @change="changeOptionCSS"
            >
              External
            </el-radio>
          </div>
          <div class="title-text">
            Blur (px)
          </div>
          <el-slider
            v-model="blur"
            :min="blurMin"
            :step="blurStep"
            :max="blurMax"
            :disabled="!selectStatus"
            @change="changeOptionCSS"
          />
          <div class="title-text">
            Solid (px)
          </div>
          <el-slider
            v-model="stretching"
            :min="stretchingMin"
            :step="stretchingStep"
            :max="stretchingMax"
            :disabled="!selectStatus"
            @change="changeOptionCSS"
          />
          <div class="title-text">
            Color
          </div>
          <el-color-picker
            v-model="color"
            show-alpha
            class="colorpicker"
            :disabled="!selectStatus"
            @change="changeOptionCSS"
          />
          <div class="title-text">
            Horizontal offset
          </div>
          <el-slider
            v-model="horizontalO"
            :min="horizontalMinO"
            :step="horizontalStepO"
            :max="horizontalMaxO"
            :disabled="!selectStatus"
            @change="changeOptionCSS"
          />
          <div class="title-text">
            Vertical offset
          </div>
          <el-slider
            v-model="verticalO"
            :min="verticalMinO"
            :step="verticalStepO"
            :max="verticalMaxO"
            :disabled="!selectStatus"
            @change="changeOptionCSS"
          />
        </div>
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOptionCSS"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BoxShadowCSS',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    },
    defaultHorizontal: {
      type: String
    },
    defaultVertical: {
      type: String
    },
    defaultBlur: {
      type: String
    },
    defaultStretching: {
      type: String
    },
    defaultColor: {
      type: String
    },
    defaultInset: {
      type: Boolean
    },
    type: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    parameter: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    eventClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.default,
      selectStatus: this.status,
      showHint: false,
      mode: this.defaultInset,
      horizontalMinO: -10,
      horizontalMaxO: 10,
      horizontalStepO: 1,
      horizontalO: this.convertPixelsToInt(this.defaultHorizontal),
      verticalO: this.convertPixelsToInt(this.defaultVertical),
      verticalStepO: 1,
      verticalMaxO: 10,
      verticalMinO: -10,
      blur: this.convertPixelsToInt(this.defaultBlur),
      blurMin: 0,
      blurMax: 20,
      blurStep: 1,
      stretching: this.convertPixelsToInt(this.defaultStretching),
      stretchingMin: 0,
      stretchingMax: 20,
      stretchingStep: 1,
      color: `${this.defaultColor}`
    }
  },
  watch: {
    clearOptionsCSS (val) {
      if (val) {
        this.selectStatus = false
      }
    },
    eventClick (val) {
      if (val) {
        this.selectStatus = val
        this.value = this.default
        this.horizontalO = this.convertPixelsToInt(this.defaultHorizontal)
        this.verticalO = this.convertPixelsToInt(this.defaultVertical)
        this.blur = this.convertPixelsToInt(this.defaultBlur)
        this.stretching = this.convertPixelsToInt(this.defaultStretching)
        this.color = `${this.defaultColor}`
        this.inset = this.defaultInset
      }
    },
    selectStatus (val) {
      if (val === true) {
        this.changeOptionCSS()
      }
    },
  },
  computed: {
    ...mapState(['clearOptionsCSS']),
  },
  methods: {
    convertPixelsToInt(value) {
      if (value) {
        const stringWithPixels = value.replace('px', '')
        return parseInt(stringWithPixels)
      }
      return 0
    },
    changeOptionCSS () {
      const inner = this.mode ? ' inset' : ''
      const horizontalO = `${this.horizontalO}px`
      const verticalO = `${this.verticalO}px`
      const blur = `${this.blur}px`
      const stretching = `${this.stretching}px`
      const color = this.color
      const value = this.selectStatus === true ?
        `${horizontalO} ${verticalO} ${blur} ${stretching} ${color}${inner}` : ''

      this.$emit('changeOptionCSS', {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ':',
        value: value
      })
    }
  }
}
</script>

<style scoped>
.mode {
  margin: 10px 0;
}
.inner-property .el-slider >>> .el-slider__runway{
  max-width: 270px;
}
.title-text {
  color: #6c7683;
}
.inner-property {
  position: relative;
  padding-left: 15px;
}
.inner-block {
  margin-bottom: 10px;
}
.el-slider {
  min-height: 38px;
}
</style>
